/**
 * TrustSection Component
 * Displays platform value propositions and trust indicators
 */

import React from "react";
import Icon from "../AppIcon";

const TrustSection: React.FC = () => {
	const features = [
		{
			icon: "Shield" as const,
			title: "Secure & Managed",
			description:
				"All payments are managed and manually verified by platform owners. Your transactions are safe and transparent.",
			color: "text-success",
			bgColor: "bg-success/10",
		},
		{
			icon: "CheckCircle" as const,
			title: "Verified Organizations & Agents",
			description:
				"Properties are tied to specific verified organizations. Roles for tenants, agents, and technicians are clearly defined.",
			color: "text-primary",
			bgColor: "bg-primary/10",
		},
		{
			icon: "Zap" as const,
			title: "Integrated Tenant Portal",
			description:
				"Once you sign up, manage leases, payments, and maintenance requests all in one place. Streamlined and efficient.",
			color: "text-accent",
			bgColor: "bg-accent/10",
		},
	];

	return (
		<section className="py-16 bg-card border-y border-border">
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				{/* Section Header */}
				<div className="text-center mb-12">
					<h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
						Why Choose Dofarahub?
					</h2>
					<p className="text-lg text-muted-foreground max-w-2xl mx-auto">
						Built with security, transparency, and ease of use in mind. We
						handle the complexity so you can focus on finding your perfect home.
					</p>
				</div>

				{/* Features Grid */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{features.map((feature, index) => (
						<div
							key={index}
							className="text-center p-6 rounded-xl hover:bg-muted/30 smooth-transition"
						>
							{/* Icon */}
							<div className="inline-flex items-center justify-center mb-4">
								<div
									className={`w-16 h-16 ${feature.bgColor} ${feature.color} rounded-full flex items-center justify-center`}
								>
									<Icon name={feature.icon} size={32} />
								</div>
							</div>

							{/* Title */}
							<h3 className="text-xl font-semibold text-foreground mb-3">
								{feature.title}
							</h3>

							{/* Description */}
							<p className="text-muted-foreground leading-relaxed">
								{feature.description}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default TrustSection;
